import { BaseSanitizer } from './BaseSanitizer';
export class SSNSanitizer extends BaseSanitizer {
    constructor(context, enabled = true) {
        super(context, 'SSN', 'ssns', enabled);
    }
    detectMatches(text) {
        // Single pattern with proper SSN validation:
        // - First 3 digits: cannot be 000, 666, or 900-999
        // - Middle 2 digits: cannot be 00
        // - Last 4 digits: cannot be 0000
        const ssnPattern = /\b(?!000|666|9\d{2})(\d{3})[- ]?(?!00)(\d{2})[- ]?(?!0000)(\d{4})\b/g;
        const matches = [];
        let match;
        while ((match = ssnPattern.exec(text)) !== null) {
            matches.push({
                originalText: match[0],
                tag: '',
                startIndex: match.index,
                endIndex: match.index + match[0].length
            });
        }
        return this.removeOverlappingMatches(matches);
    }
}
